// save ไว้ที่ D:\vuejs\project\tai_book\src\store\api\services\freezone2022Service.js
import Api from '@/services/Api'
import router from '@/router'
import store from '@/store'

export default {
  // request Service ------------------------------------
  requestList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post('freezone2022/default.asp?controller=request&action=list' + param, credentials)
  },
  requestItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post('freezone2022/default.asp?controller=request&action=listbyparam', credentials)
  },
  requestListByParam(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=request&action=listbyparam', credentials)
  },
  requestListByParam2(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=request&action=listbyparam2', credentials)
  },

  requestInsert(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=request&action=insert', credentials)
  },
  requestUpdate(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=request&action=update', credentials)
  },
  requestDelete(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=request&action=delete', credentials)
  },
  // table_receive Service ----------------------------------
  // receive Service ------------------------------------
  receiveList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post('freezone2022/default.asp?controller=receive&action=list' + param, credentials)
  },
  receiveItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post('freezone2022/default.asp?controller=receive&action=listbyparam', credentials)
  },
  receiveListByParam(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=receive&action=listbyparam', credentials)
  },
  receiveInsert(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=receive&action=insert', credentials)
  },
  receiveUpdate(credentials) {
    console.log('receiveUpdate(credentials)', credentials)
    return Api.httpServer().post('freezone2022/default.asp?controller=receive&action=update', credentials)
  },
  receiveDelete(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=receive&action=delete', credentials)
  },
  // checkfacdetail Service ------------------------------------
  checkfacdetailList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post('freezone2022/default.asp?controller=checkfacdetail&action=list' + param, credentials)
  },
  checkfacdetailItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post('freezone2022/default.asp?controller=checkfacdetail&action=listbyparam', credentials)
  },
  checkfacdetailListByParam(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=checkfacdetail&action=listbyparam', credentials)
  },
  checkfacdetailListByParam2(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=checkfacdetail&action=listbyparam2', credentials)
  },
  checkfacdetailInsert(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=checkfacdetail&action=insert', credentials)
  },
  checkfacdetailUpdate(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=checkfacdetail&action=update', credentials)
  },
  checkfacdetailDelete(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=checkfacdetail&action=delete', credentials)
  },
  // Auditperson Service ------------------------------------
  auditpersonList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post('freezone2022/default.asp?controller=auditperson&action=list' + param, credentials)
  },
  auditpersonItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post('freezone2022/default.asp?controller=auditperson&action=listbyparam', credentials)
  },
  auditpersonListByParam(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=auditperson&action=listbyparam', credentials)
  },
  auditpersonInsert(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=auditperson&action=insert', credentials)
  },
  auditpersonUpdate(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=auditperson&action=update', credentials)
  },
  auditpersonDelete(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=auditperson&action=delete', credentials)
  },
  // table_audit Service ------------------------------------
  table_auditList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post('freezone2022/default.asp?controller=table_audit&action=list' + param, credentials)
  },
  table_auditItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post('freezone2022/default.asp?controller=table_audit&action=listbyparam', credentials)
  },
  table_auditListByParam(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=table_audit&action=listbyparam', credentials)
  },
  table_auditListByParam2(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=table_audit&action=listbyparam2', credentials)
  },
  SelectReportStatus(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=table_audit&action=ReportStatus', credentials)
  },
  SelectChartStatus(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=table_audit&action=ChartStatus', credentials)
  },
  quotationSumbyTimeType(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=table_audit&action=SumDashboard', credentials)
  },
  reqbillChartDays(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=table_audit&action=ChartDays', credentials)
  },
  table_auditInsert(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=table_audit&action=insert', credentials)
  },
  table_auditUpdate(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=table_audit&action=update', credentials)
  },
  table_auditDelete(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=table_audit&action=delete', credentials)
  },
  // Receive Service ------------------------------------
  receiveList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post('freezone2022/default.asp?controller=receive&action=list' + param, credentials)
  },
  receiveItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post('freezone2022/default.asp?controller=receive&action=listbyparam', credentials)
  },
  receiveListByParam(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=receive&action=listbyparam', credentials)
  },
  receiveInsert(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=receive&action=insert', credentials)
  },
  receiveUpdate(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=receive&action=update', credentials)
  },
  receiveDelete(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=receive&action=delete', credentials)
  },
  // suplier Service ------------------------------------
  suplierList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post('freezone2022/default.asp?controller=suplier&action=list' + param, credentials)
  },
  suplierItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post('freezone2022/default.asp?controller=suplier&action=listbyparam', credentials)
  },
  suplierListByParam(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=suplier&action=listbyparam', credentials)
  },
  suplierListByParam2(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=suplier&action=listbyparam2', credentials)
  },
  suplierProcess(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=suplier&action=suplierProcess', credentials)
  },
  suplierInsert(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=suplier&action=insert', credentials)
  },
  suplierUpdate(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=suplier&action=update', credentials)
  },
  suplierDelete(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=suplier&action=delete', credentials)
  },
  // certificate Service ------------------------------------
  certificateList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post('freezone2022/default.asp?controller=certificate&action=list' + param, credentials)
  },
  certificateItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post('freezone2022/default.asp?controller=certificate&action=listbyparam', credentials)
  },
  certificateListByParam(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=certificate&action=listbyparam', credentials)
  },
  certificateInsert(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=certificate&action=insert', credentials)
  },
  certificateUpdate(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=certificate&action=update', credentials)
  },
  certificateDelete(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=certificate&action=delete', credentials)
  },
  // model Service ------------------------------------
  modelList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post('freezone2022/default.asp?controller=model&action=list' + param, credentials)
  },
  modelItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post('freezone2022/default.asp?controller=model&action=listbyparam', credentials)
  },
  modelListByParam(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=model&action=listbyparam', credentials)
  },
  modelInsert(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=model&action=insert', credentials)
  },
  modelUpdate(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=model&action=update', credentials)
  },
  modelDelete(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=model&action=delete', credentials)
  },
  // process Service ------------------------------------
  processList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post('freezone2022/default.asp?controller=process&action=list' + param, credentials)
  },
  processItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post('freezone2022/default.asp?controller=process&action=listbyparam', credentials)
  },
  processListByParam(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=process&action=listbyparam', credentials)
  },
  processInsert(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=process&action=insert', credentials)
  },
  processUpdate(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=process&action=update', credentials)
  },
  processDelete(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=process&action=delete', credentials)
  },
  // signer Service ------------------------------------
  signerList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post('freezone2022/default.asp?controller=signer&action=list' + param, credentials)
  },
  signerItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post('freezone2022/default.asp?controller=signer&action=listbyparam', credentials)
  },
  signerListByParam(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=signer&action=listbyparam', credentials)
  },
  signerInsert(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=signer&action=insert', credentials)
  },
  signerUpdate(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=signer&action=update', credentials)
  },
  signerDelete(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=signer&action=delete', credentials)
  },
  // custpassword Service ------------------------------------
  custpasswordList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post('freezone2022/default.asp?controller=custpassword&action=list' + param, credentials)
  },
  custpasswordItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post('freezone2022/default.asp?controller=custpassword&action=listbyparam', credentials)
  },
  custpasswordListByParam(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=custpassword&action=listbyparam', credentials)
  },
  custpasswordInsert(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=custpassword&action=insert', credentials)
  },
  custpasswordUpdate(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=custpassword&action=update', credentials)
  },
  custpasswordDelete(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=custpassword&action=delete', credentials)
  },
  // auditnew Service ------------------------------------
  auditnewList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post('freezone2022/default.asp?controller=auditnew&action=list' + param, credentials)
  },
  auditnewItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post('freezone2022/default.asp?controller=auditnew&action=listbyparam', credentials)
  },
  auditnewListByParam(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=auditnew&action=listbyparam', credentials)
  },
  auditnewInsert(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=auditnew&action=insert', credentials)
  },
  auditnewUpdate(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=auditnew&action=update', credentials)
  },
  auditnewDelete(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=auditnew&action=delete', credentials)
  },
  // type Service ------------------------------------
  typeList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post('freezone2022/default.asp?controller=type&action=list' + param, credentials)
  },
  typeItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post('freezone2022/default.asp?controller=type&action=listbyparam', credentials)
  },
  typeListByParam(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=type&action=listbyparam', credentials)
  },
  typeInsert(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=type&action=insert', credentials)
  },
  typeUpdate(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=type&action=update', credentials)
  },
  typeDelete(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=type&action=delete', credentials)
  },

  // Approve_mail Service ------------------------------------
  approve_mailList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post('freezone2022/default.asp?controller=approve_mail&action=list' + param, credentials)
  },
  approve_mailItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post('freezone2022/default.asp?controller=approve_mail&action=listbyparam', credentials)
  },
  approve_mailListByParam(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=approve_mail&action=listbyparam', credentials)
  },
  approve_mailInsert(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=approve_mail&action=insert', credentials)
  },
  approve_mailUpdate(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=approve_mail&action=update', credentials)
  },
  approve_mailAppvPO(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=approve_mail&action=AppvPO', credentials)
  },
  approve_mailDelete(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=approve_mail&action=delete', credentials)
  },
  // material Service ------------------------------------
  materialList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post('freezone2022/default.asp?controller=material&action=list' + param, credentials)
  },
  materialItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post('freezone2022/default.asp?controller=material&action=listbyparam', credentials)
  },
  materialListByParam(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=material&action=listbyparam', credentials)
  },
  materialInsert(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=material&action=insert', credentials)
  },
  materialUpdate(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=material&action=update', credentials)
  },
  materialDelete(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=material&action=delete', credentials)
  },
  freezoneRefno(credentials) {
    return Api.httpServer().post('tsc/default.asp?controller=arcustomer&action=freezoneRefno', credentials)
  },
  // custonline Service ------------------------------------
  custonlineList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post('freezone2022/default.asp?controller=custonline&action=list' + param, credentials)
  },
  custonlineItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post('freezone2022/default.asp?controller=custonline&action=listbyparam', credentials)
  },
  custonlineListByParam(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=custonline&action=listbyparam', credentials)
  },
  custonlineInsert(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=custonline&action=insert', credentials)
  },
  custonlineUpdate(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=custonline&action=update', credentials)
  },
  custonlineDelete(credentials) {
    return Api.httpServer().post('freezone2022/default.asp?controller=custonline&action=delete', credentials)
  },
  // vw_request Service ------------------------------------
  vw_requestList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'freezone2022/default.asp?controller=vw_request&action=list' + param,
      credentials
    )
  },
  vw_requestItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'freezone2022/default.asp?controller=vw_request&action=listbyparam' ,
      credentials
    )
  },
  vw_requestListByParam(credentials) {
    return Api.httpServer().post(
      'freezone2022/default.asp?controller=vw_request&action=listbyparam',
      credentials
    )
  },
  vw_requestInsert(credentials) {
    return Api.httpServer().post(
      'freezone2022/default.asp?controller=vw_request&action=insert',
      credentials
    )
  },
  vw_requestUpdate(credentials) {
    return Api.httpServer().post(
      'freezone2022/default.asp?controller=vw_request&action=update',
      credentials
    )
  },
  vw_requestDelete(credentials) {
    return Api.httpServer().post(
      'freezone2022/default.asp?controller=vw_request&action=delete',
      credentials
    )
  },
  //<services>
  errorHandel(res) {
    if (res.status === 401) {
      store.state.users.main = {}
      router.push('/signin')
    }
  }
}
